
import { defineComponent, ref, onBeforeMount } from "vue";
import { useRouter, useRoute } from "vue-router";
import Countdown from "vue3-countdown";
import moment from "moment";
import { useStore } from "@/store";
export default defineComponent({
  components: { Countdown },
  setup() {
    const _store = useStore();
    let examId = ref("");
    let examDate = ref("");
    let time = ref(0);
    const router = useRouter();
    const route = useRoute();
    const goBack = () => {
      router.push({
        path: "/examPaperList",
      });
    };
    const goToExam = () => {
      console.log("gogogo", examId.value);
      // router.push({
      //   path: "/examPaperList",
      // });
    };
    const handleFinish = () => {
      router.push({
        path: "/paper",
      });
      console.log("endgogogo");
    };
    onBeforeMount(() => {
      console.log("route", _store.state.examInfo);
      // examId.value = route.query.examId;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      examDate.value = _store.state.examInfo?.active_exam?.start_time;
      let inTime = moment(new Date());
      let onTime = moment(examDate.value);
      // const aa = moment.duration(examDate.value.diff(inTime, "seconds"));
      const a: any = moment.duration(onTime.diff(inTime, "seconds"));
      console.log("a", a);
      console.log("inTime", inTime);

      time.value = a * 1000;
      console.log("onTime", time.value);
    });
    return {
      examId,
      time,
      goBack,
      goToExam,
      handleFinish,
    };
  },
});
